import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { FaTwitter, FaInstagram, FaFacebookF } from "react-icons/fa";
import { FiX , FiMenu} from "react-icons/fi";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/rwdisplay'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/rwdisplay'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/rwdisplay'},
]

class Header extends Component{
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CloseMenuTrigger = this.CloseMenuTrigger.bind(this);
        window.addEventListener('load', function() {
            console.log('All assets are loaded')
        })
    }
    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }
    
    CloseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open')
    }

    render(){
        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
        const { color='default-color' } = this.props;
        let logoUrl = <img src="/assets/images/logo/logo.png" alt="Rutherford & Wheeler" />;
        return(
            <header className={`header-area header-style-two header--transparent ${color}`}>
                <div className="header-wrapper">
                    <div className="header-left d-flex align-items-center">
                        <div className="logo">
                            <a href="/">
                                {logoUrl}
                            </a>
                        </div>
                        <nav className="mainmenunav d-lg-block ml--50">
                            <ul className="mainmenu">

                                <li><Link to="/">Home</Link></li>

                                <li className="has-droupdown"><Link to="#" >Services</Link>
                                    <ul className="submenu">
                                        <li><Link to="/mount-making">Mount-Making</Link></li>
                                        <li><Link to="/display-installation">Display Installation</Link></li>
                                        <li><Link to="/design">Design</Link></li>
                                    </ul>
                                </li>

                                <li className="has-droupdown"><Link to="#" >Case Studies</Link>
                                    <ul className="submenu">
                                        <li><Link to="/duxford-case-study">Airborne Assault Exhibition</Link></li>
                                        <li><Link to="/bolton-case-study">Dinosaur Suspension Project</Link></li>
                                        <li><Link to="/wakefield-case-study">Working With Wakefield Museum</Link></li>
                                    </ul>
                                </li>

                                <li><Link to="/about">About Us</Link></li>

                                <li><Link to="/contact">Contact</Link></li>
                            </ul>
                        </nav>
                    </div>
                    <div className="header-right">
                        <div className="social-share-inner">
                            <ul className="social-share social-style--1 color-black d-flex justify-content-start liststyle">
                                {SocialShare.map((val , i) => (
                                    <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                                ))}
                            </ul>
                        </div>
                        {/* Start Humberger Menu  */}
                        <div className="humberger-menu d-block d-lg-none pl--20">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </div>
                        {/* End Humberger Menu  */}
                        <div className="close-menu d-block d-lg-none">
                            <span onClick={this.CloseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default Header;